import { Box } from '@mui/material';
import { DropDown, ChipInput, ChipInputTagErrors } from '@qrios/frontend-library';

import { FiltersFormValues } from '../../../../../../common/reports/interfaces';
import DateRangePicker from '../../../../../../common/fields/date-range-picker';
import { FILTERS, OPERATORS, BILLING_STATUSES } from '../../../../../../common/filters/constants';

import locales from '../../locales';
import { AirtimeReportCreateForm } from '../interfaces';

const CreateReportFilterForm = ({
  errors,
  touched,
  values,
  handleChange,
  handleBlur
}: FiltersFormValues<AirtimeReportCreateForm>) => (
  <Box mt={2} mb={6}>
    <DateRangePicker
      from={{ name: FILTERS.FROM, value: values.from, error: errors.from, touched: touched.from }}
      to={{ name: FILTERS.TO, value: values.to, error: errors.to, touched: touched.to }}
      handleFromChange={value => handleChange(FILTERS.FROM, value)}
      handleToChange={value => handleChange(FILTERS.TO, value)}
      handleBlur={handleBlur}
    />
    <DropDown
      label={locales.common.filters.operators.label}
      value={values.operators}
      options={OPERATORS}
      name={FILTERS.OPERATORS}
      handleChange={handleChange}
      handleBlur={handleBlur}
      multiple={true}
      placeholder={locales.common.filters.operators.placeholder}
    />
    <ChipInput
      error={errors.skus?.[(errors.skus ?? []).length - 1]}
      label={locales.common.filters.skus.label}
      value={values.skus}
      name={FILTERS.SKUS}
      handleChange={handleChange}
      handleBlur={handleBlur}
      placeholder={locales.common.filters.skus.placeholder}
      tagErrors={errors.skus as ChipInputTagErrors}
    />
    <DropDown
      label={locales.common.filters.statuses.label}
      placeholder={locales.common.filters.statuses.placeholder}
      value={values.statuses}
      options={BILLING_STATUSES}
      name={FILTERS.STATUSES}
      handleChange={handleChange}
      handleBlur={handleBlur}
      multiple={true}
    />
    <ChipInput
      error={errors.operationIds?.[(errors.operationIds ?? []).length - 1]}
      label={locales.common.filters.operationIds.label}
      value={values.operationIds}
      name={FILTERS.OPERATION_IDS}
      handleChange={handleChange}
      handleBlur={handleBlur}
      placeholder={locales.common.filters.operationIds.placeholder}
      tagErrors={errors.operationIds as ChipInputTagErrors}
    />
    <ChipInput
      error={errors.acquirerMsisdns?.[(errors.acquirerMsisdns ?? []).length - 1]}
      label={locales.common.filters.acquirerMsisdns.label}
      value={values.acquirerMsisdns}
      name={FILTERS.ACQUIRER_MSISDNS}
      handleChange={handleChange}
      handleBlur={handleBlur}
      placeholder={locales.common.filters.acquirerMsisdns.placeholder}
      tagErrors={errors.acquirerMsisdns as ChipInputTagErrors}
    />
  </Box>
);

export default CreateReportFilterForm;
